import React from 'react';

import {fetchActiveChatSessions} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadChatSessions = ({children}) => {
    useStoredDataChanged();
    return (
        <Loader id="load-chat-sessions" skipSpinner={state => state.chat.loaded} promises={[fetchActiveChatSessions()]}>
            {children}
        </Loader>
    );
};
export default LoadChatSessions;
